import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/spoiler/spoiler';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/tabs/tabs';
import 'Bem/site/checkbox/checkbox';
import 'Bem/site/book3d/book3d';
import 'Bem/site/book-page/book-page';

svgSpriteLoader('/site/book-fast-view/svg/sprite.svg?v=20180320', 'book-fast-view');